import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2)
    },
  },
  provisionSelector: {
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    width: '100%',
  },
  header: {
    fontFamily: 'Roboto',
    padding: '5px',
    paddingLeft: '15px',
    backgroundColor: '#DCDCDC',
  },
  subheader: {
    fontWeight: 'normal',
    alignContent: 'left',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  footnote: {
    fontSize: '14px'
  },
  button: {
    margin: theme.spacing(1.5),
    width: '200px'
  },
  alert: {
    marginTop: theme.spacing(1.5),
  }
});
